/* eslint-disable @typescript-eslint/no-explicit-any */
import isEmpty from 'lodash/isEmpty';
import type { Field } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/types.tsx';
import { FORMATTER, FIELD_MAPPER_MUTATION_GROUP } from '../constants.tsx';
import {
	ECOSYSTEM_API_FIELD_FORMATTER,
	ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP,
} from '../ecosystem-api-field-map/index.tsx';
import type { OldFieldMapper } from '../types.tsx';
import { mergeFormat } from './helper-functions.tsx';

const generateDefaultValuesForEcosystemAPI = (otherFields: {
	[key: string]: OldFieldMapper;
}): Field => {
	const defaultValues: Record<string, any> = {};

	const fieldIds: Array<any | string> = [];

	Object.keys(otherFields).forEach((mutationKey: string): void => {
		const mutationValue = otherFields[mutationKey];
		// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: \"singleLineTextFields\"; readonly epic: \"epicLinkField\"; readonly epicName: \"singleLineTextFields\"; readonly duedate: \"datePickerFields\"; readonly startdate: \"datePickerFields\"; ... 7 more ...; readonly components: \"components\"; }'.
		if (ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP[mutationKey]) {
			// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: \"singleLineTextFields\"; readonly epic: \"epicLinkField\"; readonly epicName: \"singleLineTextFields\"; readonly duedate: \"datePickerFields\"; readonly startdate: \"datePickerFields\"; ... 7 more ...; readonly components: \"components\"; }'.
			const mutationGroup = ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP[mutationKey];
			// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: \"singleLineTextFields\"; readonly epic: \"epicLinkField\"; readonly epicName: \"singleLineTextFields\"; readonly duedate: \"datePickerFields\"; readonly startdate: \"datePickerFields\"; ... 7 more ...; readonly components: \"components\"; }'.
			const formattedValue = ECOSYSTEM_API_FIELD_FORMATTER[mutationGroup](
				mutationKey,
				mutationValue,
			);
			if (formattedValue) {
				const { value, type } = formattedValue;
				fieldIds.push(mutationKey);
				if (!isEmpty(value)) {
					if (type === 'array') {
						(defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(value);
					} else if (type === 'object') {
						defaultValues[mutationGroup] = value;
					}
				}
			}
		}
	});
	return { defaultValues, fieldIds };
};

const generateDefaultValuesLegacy = (otherFields: { [key: string]: OldFieldMapper }): Field => {
	const defaultValues: Record<string, any> = {};

	const fieldIds: Array<any | string> = [];
	Object.keys(otherFields).forEach((mutationKey: string): void => {
		const mutationValue = otherFields[mutationKey];
		// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: \"singleLineTextFields\"; readonly epic: \"epicLinkField\"; readonly epicName: \"singleLineTextFields\"; readonly duedate: \"datePickerFields\"; readonly startdate: \"datePickerFields\"; ... 7 more ...; readonly components: \"components\"; }'.
		if (FIELD_MAPPER_MUTATION_GROUP[mutationKey]) {
			// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: \"singleLineTextFields\"; readonly epic: \"epicLinkField\"; readonly epicName: \"singleLineTextFields\"; readonly duedate: \"datePickerFields\"; readonly startdate: \"datePickerFields\"; ... 7 more ...; readonly components: \"components\"; }'.
			const mutationGroup = FIELD_MAPPER_MUTATION_GROUP[mutationKey];
			// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly singleLineTextFields: { readonly value: { readonly fieldId: \"ID\"; readonly text: null; }; readonly type: \"array\"; }; readonly epicLinkField: { readonly value: { readonly fieldId: \"ID\"; readonly epicLink: { readonly issueKey: null; }; }; readonly type: \"object\"; }; ... 7 more ...; readonly components: { .....'.
			const { type = null, value: depth = null } = FORMATTER[mutationGroup];
			let pattern = null;
			if (!isEmpty(mutationValue) && depth && type) {
				if (!Array.isArray(mutationValue) && typeof mutationValue === 'object') {
					const { fieldId, fieldValue } = mutationValue;
					// If fieldValue is different from the key like custom fields
					pattern = mergeFormat(depth, fieldId || mutationKey, fieldValue);
					fieldIds.push(fieldId || mutationKey);
				} else {
					// same as key like summary etc.
					pattern = mergeFormat(depth, mutationKey, mutationValue);
					fieldIds.push(mutationKey);
				}
			}
			// merge mutations based on type as some mutations are object whereas others are arrays
			if (!isEmpty(pattern)) {
				if (type === 'array') {
					(defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(pattern);
				} else if (type === 'object') {
					defaultValues[mutationGroup] = pattern;
				}
			}
		}
	});
	return { defaultValues, fieldIds };
};

const generateDefaultValues = (
	otherFields: { [key: string]: OldFieldMapper },
	isEcosystemAPI = false,
): Field => {
	if (isEcosystemAPI) return generateDefaultValuesForEcosystemAPI(otherFields);
	return generateDefaultValuesLegacy(otherFields);
};

export { generateDefaultValues };
